import script from "./vgrapheddashboarddata.vue?vue&type=script&setup=true&lang=js"
export * from "./vgrapheddashboarddata.vue?vue&type=script&setup=true&lang=js"

import "./vgrapheddashboarddata.vue?vue&type=style&index=0&id=104c18e0&lang=css"

const __exports__ = script;

export default __exports__